match_current_hostname = (fragment) ->
  return window.location.hostname.indexOf(fragment) != -1

SENTRY_URL = null

if match_current_hostname('app') or match_current_hostname('app-production')
  ENVIRONMENT = 'production'
else if match_current_hostname('app-certification')
  ENVIRONMENT = 'certification'
else if match_current_hostname('kvasir-stage')
  ENVIRONMENT = 'stage'
else if match_current_hostname('kvasir-qa')
  ENVIRONMENT = 'qa'
else if match_current_hostname('kvasir-data')
  ENVIRONMENT = 'data'
else if match_current_hostname('mrs')
  ENVIRONMENT = 'mrs'

module.exports =
  API_ROOT: '/workflow/api/v1/'
  API_ROOT_TEST: 'http://localhost:5001/workflow/api/v1/'
  TWAIN_SERVICE: 'https://arachnys-twain.herokuapp.com/'
  NEWS_FAVICON_URL: 'https://s3.amazonaws.com/arachnys-sources-favicons/'

  FACTIVA_AUTHENTICATE: 'https://api.beta.dowjones.com/api/Public/2.0/Session/json'

  UDA_IDS: [
      # Chrome extension (mrs)
      'npgkblhjjhekainkfcilgecgafjhegon',
      # Chrome extension (latest)
      'pgacpihaiahcohbkodakojkdphcpfjam',
      # Microsoft Edge extension
      'oldfiafaajgipfeopnkccjpafihihgeb'
  ]
  UDA_POLLING_INTERVAL: 5000

  ENVIRONMENT: ENVIRONMENT
  SENTRY_URL: SENTRY_URL
  GIT_SHA: process.env.GIT_SHA

  WORKER_POLLING_INTERVAL: 2000
  DOCUMENT_POLLING_INTERVAL: 2000
  # REPORT_POLLING_INTERVAL was 15000, increased to reduce demand
  # on database (should be changed back in the future)
  REPORT_POLLING_INTERVAL: 30000
  QUICK_CREATED_REPORT_POLLING_INTERVAL: 2000
  SEARCH_RESULTS_PER_PAGE: 10
  SEARCH_RESULTS_PER_PAGE_LARGE: 50
  SEARCH_RESULTS_PER_PAGE_MEDIUM: 20
  REPORTS_PER_PAGE: 10
  LOG_ENTRIES_PER_PAGE: 10

  MAX_STEPS_IN_WORKFLOW_TEMPLATE: 25
